import store from '../store'
import { get } from 'lodash'
import useStorage from '@/hooks/storage'
import zh from './locales/zh'
import en from './locales/en'
import th from './locales/th'

const { getStorage } = useStorage()

// 默认语言包
const defaultTranslations = {
  zh,
  en,
  th,
}

// 获取翻译数据，如果不存在则使用默认值
function getTranslations() {
  if (Object.keys(store.state.languageData).length > 0) {
    return store.state.languageData
  }
  const localData = localStorage.getItem('languageData')
  if (localData) {
    try {
      const parsed = JSON.parse(localData)
      if (parsed && typeof parsed === 'object') {
        return parsed
      }
    } catch (e) {
      console.warn('Failed to parse languageData from localStorage:', e)
    }
  }
  return defaultTranslations
}

let translations = getTranslations()

export function specialTranslate(pathArr, val) {
  let language = getStorage('language') || 'zh'
  if (!language) {
    language = 'zh'
  }

  // 重新获取翻译数据（可能在运行时已更新）
  translations = getTranslations()

  // 安全检查
  if (!translations || !translations[language]) {
    translations = defaultTranslations
    language = 'zh'
  }

  if (!translations[language] || !translations[language][pathArr[0]] || !translations[language][pathArr[0]][pathArr[1]]) {
    return val
  }

  return translations[language][pathArr[0]][pathArr[1]][val] || val
}

export function t(path) {
  let language = getStorage('language') || 'zh'
  if (!language) {
    language = 'zh'
  }

  // 重新获取翻译数据（可能在运行时已更新）
  translations = getTranslations()

  // 安全检查
  if (!translations || !translations[language]) {
    translations = defaultTranslations
    language = 'zh'
  }

  return get(translations[language], path) || path
}
